module.exports = __webpack_public_path__ + "img/6-1.0353e1c5.jpg";